import {
  RESET,
  SET_ACTIVITIES_MODAL,
  SET_ACTIVITY,
  SET_ERRORS,
  SET_SNACKBAR
} from "../utils/constants";

import Vue from "vue";
import Vuex from "vuex";

import modules from "./modules";

Vue.use(Vuex);

const initialState = () => ({
  errors: {},
  showSnackbar: false
});

const state = {
  ...initialState()
};

const getters = {
  getErrorMessage: state => field => {
    return state.errors && state.errors[field] ? state.errors[field][0] : null;
  }
};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const mutations = {
  [SET_ERRORS](state, payload) {
    state.errors = payload;
  },
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_SNACKBAR](state, payload) {
    state.showSnackbar = payload;
  }
};
const actions = {
  reset({ commit }) {
    // resets state of all the modules
    Object.keys(modules).forEach(moduleName => {
      if (moduleName !== "Navigation") {
        commit(`${moduleName}/${RESET}`);
      }
    });
    commit(RESET);
  },
  showActivities({ commit }, { id }) {
    axios({
      method: "GET",
      url: `activities/${id}`
    }).then(response => {
      commit(`Activity/${SET_ACTIVITY}`, response.data.data);
      commit(`Modal/${SET_ACTIVITIES_MODAL}`, true);
    });
  }
};

export default new Vuex.Store({
  modules,
  state,
  mutations,
  actions,
  getters
});
